import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import { toast } from "react-toastify";
const AccountGroupForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});
   
  const [accountHead, setAccountHead] = useState(null);
 
    
    

    const {
      sendRequest: postProcurementReciept,  } = useHttp();



  const submitHandler = (e) => {
    e.preventDefault();
  
    const data = {
        
      accountHead: frmRef.current.accountHead.value.trim() ,
      accountGroupName: frmRef.current.AccountGroupName.value.trim(),    
      accountGroupCode: frmRef.current.AccountGroupCode.value.trim() ,      
      status:1,       
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),      
    };
     
    if (props.update) {
      data["procurementRecieptId"] = props.update.procurementRecieptId;
    }
    postProcurementReciept(
      {
        url: "/api/accountGroup/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {

        var error=false
        var msg =`Account group detail ${props.update ? "updated" : "added"} `;
       if(data=="Account group name/code already present")
            { msg=`Account group name/code already present`;          
            error=true;
      }
        toast.success(msg);
        props.addForm(error);
      }
    );
  }; 



  return (
    <>
      <div className="content-wrapper">
        <div>
          &nbsp;
        </div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Account Group Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">

                  <div className="col-md-4">
                      <div className="form-group">
                      <label>    Group Type </label>
                     
                <select
          id="emp_id" required
          className="form-control"
          ref={(el) => (frmRef.current["accountHead"] = el)}
          value={accountHead}
          onChange={(e) => {
            setAccountHead(e.target.value);
            
          }}
        > 
         <option selected disabled value="">--Select Group Type--</option>
           
         <option> Asset</option>
         <option>Expenses</option>
         <option>Income	</option>
         <option>Liability</option>
        </select>

                       
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Account Group Name</label>
                      
                      
                        <input
                  type={"text"}
                  id={"AccountGroupName"}
                   
                  ref={(el) => (frmRef.current["AccountGroupName"] = el)}
                  className="form-control"
                />
                
                   
                        
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                      <label>Account Group Code </label>
                      <input
                  type={"text"}
                  id={"AccountGroupCode"}
          
                  
                  ref={(el) => (frmRef.current["AccountGroupCode"] = el)}
                  className="form-control"
                />
                      </div>
                    </div>

                   
                  </div>
                

                    
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button className="btn  btn-primary mx-2 my-2" type="submit">
                        Add
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default AccountGroupForm;
